import {Model} from '@vuex-orm/core'
import {Article, Entete} from '@/models'

export class LigneRetro extends Model {
  static entity = 'LigneRetro'

  static fields () {
    return {
      id: this.number(null),
      quantite: this.number(null),
      designation: this.string(''),
      prixNetTTC: this.string(''),
      montantRemiseTTC: this.string(''),
      entete: this.belongsTo(Entete, 'entete_id'),
      articleSoftId: this.number(null),
      article: this.hasOne(Article, 'ligne_id'),
      retrocession_id: this.number(null),
      entete_id: this.number(null)
    }
  }
}
